import { Translation } from '@dxp-module/common'
import { Link as MaterialLink, Typography } from '@mui/material'
import { Box } from '@mui/system'
import { FunctionComponent } from 'react'
import { useIntl } from 'react-intl'
import tradeInBannerStyles from './tradeInBanner.styles'

const TradeInBanner: FunctionComponent = () => {
  const styles = tradeInBannerStyles()

  const intl = useIntl()

  return (
    <Box className={styles.container} data-test="myAccount:tradeIn:container">
      <Typography component={'p'}>
        <Typography
          component={'span'}
          data-test="myAccount:tradeIn:support_text_one"
        >
          <Translation id="trans__checkout__next_step__summary_on_the_right__trade_in__value_my_car" />
        </Typography>{' '}
        <Typography
          component={'span'}
          data-test="myAccount:tradeIn:support_text_two"
        >
          <Translation id="trans__checkout__next_step__summary_on_the_right__trade_in_description" />
        </Typography>{' '}
        <MaterialLink
          data-test="myAccount:tradeIn:link"
          className={styles.link}
          target="_blank"
          underline={'always'}
          href={intl.formatMessage({
            id: 'trans__configurator__customise_page_summary_section__trade_in_URL',
          })}
        >
          <Translation id="trans__configurator__customise_page_summary_section__trade_in_label" />
        </MaterialLink>
      </Typography>
    </Box>
  )
}

export default TradeInBanner
